import React, { useState } from 'react';
import { IconButton, makeStyles, TableRow, TableCell, Collapse, Box } from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { TabDocumentacionHce } from './TabDocumentacionHce';



const useStyles = makeStyles({
    iconEstado: {
        '&:hover': {
            backgroundColor: '#80808026',
        },
    },
});

const optionsfecha = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
};

export const EstudiosSolicitadosItem = (props) => {

    const classes = useStyles();
    const [openImagenes, setOpenImagenes] = useState(false);

    const { estudioS } = props;

    return (
        <React.Fragment>
            {/* {openDiag && (
                <InformeOftalmoItem
                    open={openDiag}
                    close={() => {
                        setOpenDiag(false);
                    }}
                    titulo={tituloModal}
                    disabled={true}
                    informe={informe}
                />
            )} */}
            <TableRow className={classes.iconEstado}>
                <TableCell>{estudioS?.descripcionEstudio}</TableCell>
                <TableCell>{estudioS?.descripcionProblema}</TableCell>
                <TableCell>{estudioS?.nombreMedico}</TableCell>
                <TableCell>{estudioS?.descripcionEspecialidad}</TableCell>
                <TableCell>
                    {new Date(estudioS?.fechaCarga).toLocaleString('es', optionsfecha)}
                </TableCell>
                <TableCell>{estudioS?.descripcion}</TableCell>
                <TableCell> Imagenes
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() =>
                            setOpenImagenes(
                                (prevOpenImagenes) => !prevOpenImagenes
                            )
                        }
                    >
                        {openImagenes ? (
                            <KeyboardArrowUp />
                        ) : (
                            <KeyboardArrowDown />
                        )}
                    </IconButton>
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell
                    style={{
                        paddingBottom: 0,
                        paddingTop: 0,
                        paddingLeft: 50,
                    }}
                    colSpan={8}
                >
                    <Collapse in={openImagenes} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                           <TabDocumentacionHce estudioS={estudioS} />
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}


